import React, { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import toast from 'react-hot-toast';
import { createAPIEndPoint } from 'config/api/api';
import Loader from 'loaders/Loader';
import { logoutUser } from 'utils';
import { useNavigate } from 'react-router-dom';
import { getUserData } from 'utils';
import ClinicTable from './components/ClinicTable';

const Clinic = () => {
  const navigate = useNavigate();
  const userData = getUserData();
  const clinic_id = userData?.clinic_id ?? null;

  const [clinics, setClinics] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchClinics = async () => {
    setLoading(true);
    try {
      const response = await createAPIEndPoint('clinic').fetchAll(); // Still fetching assistants
      setClinics(response.data.clinics || []);
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Error fetching clinics');
      if (err?.response?.data?.error?.includes('Bearer token')) {
        logoutUser(navigate);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClinics();
  }, []);

  return (
    <Box pt={{ base: '80px', md: '80px', xl: '80px' }}>
      {loading && <Loader />}
      <ClinicTable
        tableData={clinics}
        loading={loading}
        fetchAgain={fetchClinics}
      />
    </Box>
  );
};

export default Clinic;
